export default "__VITE_ASSET__741cbdf9__"